import { useMediaQuery } from './useMediaQuery';

/**
 * Retorna true em viewports `<=768px`. Single source of truth pro breakpoint mobile.
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 768px)');
}
